<template>
    <div>
        <v-card-title>
            <span class="headline">Właściwości</span>
        </v-card-title>
        <v-text-field
            v-model="editable.length"
            :label="$t('materials.length')"
            :error-messages="fieldErrors('length')"
            type="number"
            @input="changeValue">
        </v-text-field>
        <v-text-field
            v-model="editable.width"
            :label="$t('materials.width')"
            :error-messages="fieldErrors('width')"
            type="number"
            @input="changeValue">
        </v-text-field>
        <v-text-field
            v-model="editable.height"
            :label="$t('materials.height')"
            :error-messages="fieldErrors('height')"
            type="number"
            @input="changeValue">
        </v-text-field>
        <v-text-field
            v-model="editable.dilatation"
            :label="$t('materials.dilatation')"
            :error-messages="fieldErrors('dilatation')"
            type="number"
            @input="changeValue">
        </v-text-field>
        <v-text-field
            v-model="editable.min_length"
            :label="$t('materials.min_length')"
            :error-messages="fieldErrors('min_length')"
            type="number"
            @input="changeValue">
        </v-text-field>
        <v-text-field
            v-model="editable.color"
            :label="$t('materials.color')"
            :error-messages="fieldErrors('color')"
            @input="changeValue">
        </v-text-field>
        <v-text-field
            v-model="editable.priority"
            :label="$t('materials.priority')"
            type="number"
            @input="changeValue">
        </v-text-field>

        <template v-if="plankId">
            <v-divider class="my-4"></v-divider>
            <v-subheader>{{ $t('materials.relations.title') }}</v-subheader>
            <v-select
                v-model="relations.slats"
                :items="slatOptions"
                :item-text="optionLabel"
                item-value="id"
                :label="$t('materials.relations.slats')"
                multiple chips small-chips deletable-chips>
            </v-select>
            <v-select
                v-model="relations.joists"
                :items="joistOptions"
                :item-text="optionLabel"
                item-value="id"
                :label="$t('materials.relations.joists')"
                multiple chips small-chips deletable-chips>
            </v-select>
            <v-select
                v-model="relations.surfaces"
                :items="surfaceOptions"
                :item-text="optionLabel"
                item-value="id"
                :label="$t('materials.relations.surfaces')"
                multiple chips small-chips deletable-chips>
            </v-select>
            <v-btn
                :loading="savingRelations"
                color="primary" small dark
                @click="saveRelations">
                {{ $t('base.save') }}
            </v-btn>
            <span v-if="relationsSaved" class="green--text ml-2">{{ $t('materials.relations.saved') }}</span>
        </template>
        <div v-else class="grey--text caption mt-2">
            {{ $t('materials.relations.hint') }}
        </div>
    </div>
</template>
<script>
export default {
        name: "PlankForm",
        props: {
            item: {},
            errors: {
                type: Object,
                default: () => ({})
            }
        },
        data() {
            return {
                editable: {
                    length: 0,
                    width: 0,
                    height: 0,
                    name: '',
                    dilatation: 0,
                    min_length: 0,
                    color: '',
                    priority: 0
                },
                relations: {
                    slats: [],
                    joists: [],
                    surfaces: []
                },
                savingRelations: false,
                relationsSaved: false
            }
        },
        computed: {
            plankId() {
                return this.item.plank ? this.item.plank.id : null
            },
            slatOptions() {
                return this.$store.state.materials.slats
            },
            joistOptions() {
                return this.$store.state.materials.joists
            },
            surfaceOptions() {
                return this.$store.state.materials.surfaces
            }
        },
        methods: {
            fieldErrors(field) {
                return this.errors['plank.' + field] || []
            },
            changeValue(){
                this.editable.name = this.item.description.pl
                this.$emit('itemChange', this.editable)
            },
            optionLabel(option) {
                return typeof option.name === 'string' ? option.name : option.name[this.$locale]
            },
            loadRelations() {
                Promise.all([
                    this.$http.post('plankslats', {id: this.plankId}),
                    this.$http.post('plankjoists', {id: this.plankId}),
                    this.$http.post('planksurfaces', {id: this.plankId})
                ]).then(([slats, joists, surfaces]) => {
                    this.relations.slats = slats.data.map(slat => slat.id)
                    this.relations.joists = joists.data.map(joist => joist.id)
                    this.relations.surfaces = surfaces.data.map(surface => surface.id)
                })
            },
            saveRelations() {
                this.savingRelations = true
                this.relationsSaved = false
                this.$http.post('planks/' + this.plankId + '/relations', this.relations)
                    .then(() => {
                        this.relationsSaved = true
                    })
                    .finally(() => {
                        this.savingRelations = false
                    })
            }
        },
        mounted() {
            if(this.item.plank)
            {
                this.editable = this.item.plank

            }
            this.changeValue()
            if(this.plankId) {
                this.loadRelations()
            }
        },

}
</script>
